import { ListPickWithCustomFetcherProps } from '../../../components/ListPicker/useListPick.types';
import {
  UseOptimisticListPickProps,
  UseOptimisticListPickWithCustomFetcherProps,
} from '../../../components/ListPicker/useOptimisticListPick.types';

interface CreateParamsToUseOptimisticListPickWhenOfflineParams {
  isOnline: boolean;
  onlineProps: UseOptimisticListPickProps<any>;
  offlineFetcher: ListPickWithCustomFetcherProps['customFetcher'];
  offlineFetcherToInitialValues: UseOptimisticListPickWithCustomFetcherProps<any>['customFetcherToInitialValues'];
}

export const createParamsToUseOptimisticListPickWhenOffline = ({
  isOnline,
  onlineProps,
  offlineFetcher,
  offlineFetcherToInitialValues,
}: CreateParamsToUseOptimisticListPickWhenOfflineParams): UseOptimisticListPickProps<any> => {
  if (isOnline) {
    return onlineProps;
  }

  return {
    defaultValue: onlineProps.defaultValue,
    customFetcherToInitialValues: offlineFetcherToInitialValues,
    listPickProps: {
      customFetcher: offlineFetcher,
      queryField: onlineProps.listPickProps.queryField,
    },
  };
};
